import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import {
    IOrganization,
    IShareOrganization,
} from '../../components/Layout/Navbar/interfaces'
import { fetchProgramOrgsByOrgId } from '../../services/entityInstanceServices'
import { UserPermissions } from '../../constants/constants'

interface OrgState {
    shareOrgList: IShareOrganization[]
    org: IOrganization | null
    permissions: UserPermissions[]
    enabledApplications: string[]
    loadingPermissions: boolean
}

const initialState: OrgState = {
    shareOrgList: [],
    org: null,
    permissions: [],
    enabledApplications: [],
    loadingPermissions: false,
}

export const updateSharedOrgsList = createAsyncThunk(
    'org/updateSharedOrgsList',
    async (orgId: string) => {
        const response = await fetchProgramOrgsByOrgId(orgId || '')
        return response
    },
)

const orgSlice = createSlice({
    name: 'org',
    initialState,
    reducers: {
        updateOrg(state, action) {
            state.org = action.payload
        },
        updatePermissions(state, action) {
            state.permissions = action.payload
        },
        updateEnabledApplications(state, action) {
            state.enabledApplications = action.payload
        },
        updateLoadingPermissions(state, action) {
            state.loadingPermissions = action.payload
        },
    },
    extraReducers: (builder) => {
        builder

            .addCase(
                updateSharedOrgsList.fulfilled,
                (state, action: PayloadAction<IShareOrganization[]>) => {
                    state.shareOrgList = action.payload
                },
            )
            .addCase(updateSharedOrgsList.rejected, (state) => {
                state.shareOrgList = []
            })
    },
})

export const {
    updateOrg,
    updatePermissions,
    updateEnabledApplications,
    updateLoadingPermissions,
} = orgSlice.actions

export default orgSlice.reducer
